import React, { useState } from 'react';

// import Button from '@components/elements/Button';
import { useLocation } from 'react-router-dom';

import ConnectWallet from '../connect-wallet';
import { useWeb3React } from '@web3-react/core';
import 'react-dropdown/style.css';
import { logo, menuIcon, user } from '../../../assets/icons';
import Button from '../../elements/Button';
import { shorten } from '../../../utils/formatters';
import useAuthConnect from '../../../features/Auth/hooks/useAuthConnect';
import { arIcon, deIcon, enIcon, zhcnIcon, zhtwIcon } from '@config/flag';
import { T } from 'react-translator-component';
import { useLanguage, useLanguageActions } from '@hooks/useLanguage';
import SelectComponent from '@components/elements/SelectComponent';
import { useEffect } from 'react';

const VALID_PATH = new Set(['win', 'portfolio', 'liquidity', 'loan', 'swap', 'stake', 'lock_to_earn']);

const Header = ({ openNav, showLangSelect }: any) => {
  const { language } = useLanguage();
  const { setLanguage } = useLanguageActions();

  const options = [
    { value: 'en', label: 'English', icon: enIcon },
    { value: 'de', label: 'Deustch', icon: deIcon },
    { value: 'ar', label: 'العربية', icon: arIcon },
    { value: 'zhcn', label: '简体中文', icon: zhcnIcon },
    { value: 'zhtw', label: '繁體中文', icon: zhtwIcon },
  ];

  const [selectedValue, setSelectedValue] = useState(options.filter(option => option.value === language)[0] ? options.filter(option => option.value === language)[0] : options[0]);

  function capitalizeFirstLetter(string: String) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  function isValidPath(path: String) {
    if (path.indexOf('/') < 0) return false;
    const parts = path.split('/');
    if (parts.length < 3) return false;
    return VALID_PATH.has(parts[2].toLowerCase());
  }

  useEffect(() => {
    setLanguage({ language: selectedValue?.value });
  }, [selectedValue, setLanguage]);

  const location = useLocation();
  const [openConnectModal, setOpenConnectModal] = useState(false);
  const { logout } = useAuthConnect();
  const { account } = useWeb3React();

  return (
    <nav>
      <section className="flex items-center justify-between">
        <div className="flex items-center">
          <button onClick={openNav} className="block lg:hidden">
            <img src={menuIcon} alt="menu" />
          </button>

          <div className="ml-5 w-20 md:block md:w-28 lg:hidden">
            <img src={logo} alt="Logo" />
          </div>
        </div>

        <div className="hidden lg:block mr-auto">
          {
            location && isValidPath(location?.pathname) && <h2 className="font-semibold md:text-xl text-white capitalize">
              {T(capitalizeFirstLetter(location?.pathname.split('/')[2].replaceAll('_', ' ')))}
            </h2>
          }
        </div>
        <div className="flex items-center justify-between">
          {showLangSelect && <div className="md:block md:w-40 text-xs md:text-base">
            <SelectComponent
              selectedValue={selectedValue}
              setSelectedValue={setSelectedValue}
              options={options}
            />
          </div>
          }
          <div className="ml-4">
            <div>
              {account && (
                <div className="text-white flex items-center cursor-pointer">
                  <img src={user} alt="User profile" />
                  <span className="ml-2">{shorten(account)}</span>
                </div>
              )}
            </div>
            {!account && (
              <Button
                onClick={() => !account && setOpenConnectModal(true)}
                className="transition-all duration-600 ease-in-out text-white text-xs lg:text-base hover:bg-gradient-to-r hover:from-[#047CFD] hover:to-primary rounded-lg lg:rounded-xl"
                label={account ? shorten(account) : T('Connect Wallet')}
              />
            )}
          </div>
          {account && (
            <div className="ml-4">
              <Button
                onClick={() => logout()}
                className="transition-all duration-600 hidden lg:block ease-in-out text-white text-xs lg:text-base hover:bg-gradient-to-r hover:from-[#047CFD] hover:to-primary rounded-lg lg:rounded-xl"
                label={T('Disconnect')}
              />
            </div>
          )}
        </div>
      </section>
      {openConnectModal && (
        <ConnectWallet modalClose={() => setOpenConnectModal(false)} />
      )}
    </nav>
  );
};

export default Header;
